/* eslint-disable react-hooks/exhaustive-deps */
import { Add, Delete, Edit } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  Divider,
  IconButton,
  Skeleton,
  Slide,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { forwardRef, useRef, useState } from 'react';
import CreateExam from 'src/pages/Courses/CreateExam';
import CreateStep from 'src/pages/Courses/CreateStep';
import { deleteStep } from 'src/services';

export function CourseSteps({ steps, setSteps, error, cb, loading, courseProperty }) {
  const dragItem = useRef();
  const dragOverItem = useRef();
  const { enqueueSnackbar } = useSnackbar();

  const [selectedStep, setSelectedStep] = useState({});
  const [open, setOpen] = useState(false);
  const [onCreateExam, setOnCreateExam] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [examData, setExamData] = useState({});
  const onDragStart = (e, position) => (dragItem.current = position);
  const onDragEnter = (e, position) => (dragOverItem.current = position);
  const onDragEnd = (e) => {
    const copyListItems = [...steps];
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setSteps(copyListItems);
  };
  const onDeleteStep = async (courseStepID) => {
    setDeleting(true);
    try {
      await deleteStep(courseStepID);
      cb();
      setDeleting(false);
    } catch (error) {
      setDeleting(false);
      enqueueSnackbar('خطا در حذف گام دوره', { variant: 'error' });
    }
  };

  return (
    <>
      {steps.length > 0 ? (
        <>
          {steps.map((item, index) => (
            <div
              key={index}
              draggable
              onDragStart={(e) => onDragStart(e, index)}
              onDragEnter={(e) => onDragEnter(e, index)}
              onDragEnd={() => onDragEnd()}
            >
              <SingleStep
                step={item}
                onOpen={(s) => {
                  if (s.type === 4) {
                    setExamData({
                      id: s._id,
                      title: s.title,
                      score: s.score,
                      passScore: s.passScore,
                      questions: s.questions,
                    });
                    setOnCreateExam(true);
                  } else {
                    setOpen(true);
                    setSelectedStep(s);
                  }
                }}
                onDelete={(sID) => !deleting && onDeleteStep(sID)}
                deleting={deleting}
              />
            </div>
          ))}
          {loading && (
            <Skeleton
              variant="rectangular"
              width={'100%'}
              height={'5rem'}
              sx={{ my: 3, borderRadius: 1, width: '100%' }}
            />
          )}
        </>
      ) : (
        // no item
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            my: 5,
          }}
        >
          <img src={'/images/Vector-Cloud.jpg'} alt="Not Item Found" style={{ width: 305, height: 'auto' }} />
          <Typography fontSize={14} fontWeight={700} sx={{ mt: 3 }}>
            هنوز گامی ایجاد نشده است
          </Typography>
        </Box>
      )}
      <Stack direction={'row'} alignItems={'center'} gap={2}>
        <Button variant="outlined" size="large" endIcon={<Add />} onClick={() => setOpen(true)}>
          افزودن گام جدید
        </Button>
        <Tooltip title={steps.length === 0 ? 'برای ایجاد آزمون باید حداقل یک گام ایجاد کنید.' : ''}>
          <div>
            <Button
              variant="outlined"
              size="large"
              endIcon={<Add />}
              disabled={steps.length === 0}
              onClick={() => setOnCreateExam(true)}
            >
              ایجاد آزمون
            </Button>
          </div>
        </Tooltip>
      </Stack>

      {/* {error && steps.length === 0 && (
        <Typography variant="caption" sx={{ display: 'block', color: '#FF4842', mt: 1 }}>
          لطفا گام های دوره را ایجاد کنید
        </Typography>
      )} */}
      <Dialog
        fullScreen
        open={open}
        onClose={() => setOpen(false)}
        TransitionComponent={Transition}
        disableEscapeKeyDown
      >
        <CreateStep
          onClose={() => {
            setOpen(false);
            setSelectedStep({});
          }}
          cb={() => cb()}
          selectedStep={selectedStep}
          courseProperty={courseProperty}
        />
      </Dialog>
      <Dialog
        fullScreen
        open={onCreateExam}
        onClose={() => setOnCreateExam(false)}
        TransitionComponent={Transition}
        disableEscapeKeyDown
      >
        <CreateExam
          initialData={examData}
          onCancel={() => setOnCreateExam(false)}
          onCreate={() => {
            cb();
            setOnCreateExam(false);
          }}
        />
      </Dialog>
    </>
  );
}

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SingleStep = ({ step, onOpen, onDelete, deleting }) => {
  const { title, _id } = step;
  return (
    <Stack
      display="flex"
      flexDirection="row"
      alignItems="center"
      sx={{
        my: 3,
        bgcolor: '#fff',
        border: '1px solid #774c9e80',
        width: '100%',
        px: 3,
        py: 1.5,
        borderRadius: 1,
        cursor: 'grab',
      }}
    >
      <Typography>{title}</Typography>

      <Box sx={{ flexGrow: 1 }} />

      <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 3, bgcolor: '#7635dc' }} />

      {deleting ? (
        <CircularProgress size={24} />
      ) : (
        <IconButton onClick={() => onDelete(_id)}>
          <Delete />
        </IconButton>
      )}
      <IconButton onClick={() => onOpen(step)}>
        <Edit />
      </IconButton>
    </Stack>
  );
};
